import { SEO_META_TAGS } from "./constants";

export const constructTitle = (pageTitle) => {
  if (pageTitle) {
    return `${pageTitle} | Hatch`;
  }

  return `Hatch`;
};

export const constructUrl = (url) => {
  if (!url) {
    console.error("url is required");
    return null;
  }

  const hostname = window ? window.location.host : null;
  const protocol = window ? window.location.protocol : "https:";

  if (!hostname) {
    return null;
  }

  // Remove trailing slash
  const path = url.replace(/\/$/, "");

  return `${protocol}//${hostname}${path}`;
};

export const constructCanonicalLink = (pathname) => {
  const url = constructUrl(pathname);

  if (!url) {
    return [];
  }

  return [
    {
      rel: "canonical",
      href: url,
    },
  ];
};

export const constructMetaTags = ({
  noIndex,
  pathname,
  description,
  title = SEO_META_TAGS.title,
  image = SEO_META_TAGS.image,
} = {}) => {
  let metaTags = [
    {
      property: "fb:app_id",
      content: process.env.REACT_APP_FACEBOOK_APP_ID,
    },
    {
      property: "og:title",
      content: title,
    },
    {
      property: "og:site_name",
      content: SEO_META_TAGS.siteName,
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:image",
      content: image,
    },
    {
      name: "twitter:card",
      content: "summary",
    },
    {
      name: "twitter:site",
      content: "@hatchforsleep",
    },
    {
      name: "twitter:title",
      content: title,
    },
  ];

  if (description) {
    // Description meta tag shows in search  results (affects SEO rankings).
    // og:description is only used in social shares of content.
    metaTags = [
      ...metaTags,
      {
        name: "description",
        content: description,
      },
      {
        property: "og:description",
        content: description,
      },
    ];
  }

  if (noIndex) {
    return [
      ...metaTags,
      {
        name: "robots",
        content: "noindex",
      },
    ];
  }

  // Include og:url since this isn't a "noindex" page
  const url = constructUrl(pathname);

  if (url) {
    metaTags = [
      ...metaTags,
      {
        property: "og:url",
        content: url,
      },
    ];
  }

  return metaTags;
};
